import {IAngularEvent, IController, IModule} from "angular";

const css = require('./ropert.scss');

export class RopertKomponent implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wkRopert', {
                bindings: {
                    vedSkjul: '&'
                },
                controller: RopertKomponent.forInjisering(),
                template: require('./ropert.html'),
                transclude: true
            })
    }

    static forInjisering() {
        return [RopertKomponent]
    }

    vedSkjul: (arg: {}) => any; //settes via bindings
    skjult = false;

    skjul($event: IAngularEvent) {
        this.skjult = true;
        this.vedSkjul({});
        $event.stopPropagation();
    }
}
